import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal, Radio, Tooltip, Upload} from "antd";
import {t} from "i18next";
import {
    createCopyLinkByLibraryItem,
    generateUUID2,
    getFileName, getFileNameExt, getImageExt, getImagePath,
    getImagePathWithTheme, getYoutubeThumbUrl,
    isArray, isBaiduVideoUrl, isBilibiliUrl,
    isDarkMode,
    isImage, isInPageLibrary,
    isNoteElement,
    isStringNullOrEmpty, isSupportVideoAnnoUrl, isVideo, isYoutubeUrl
} from "@/utils";
import Dragger from "antd/es/upload/Dragger";
import {getNoteJsonDoc, updateNoteDoc} from "@model/note";
import {
    EVENT_OPEN_LIBRARY_ITEM,
    EVENT_SWITCH_HOME_LIST_MENU,
    IMPORT_FILE_MODE_ASKME,
    IMPORT_FILE_MODE_IMPORTMODE,
    KEY_FILE_IMPORT_MODE,
    KEY_FILE_IMPORT_MODE_LIBRARY, MAX_Z_INDEX
} from "@/Const";
import {ipcInvoke, ipcOn, ipcRemoveThisAll} from "@/common/ipc";
import {isValidUrl} from "../../../@excalidraw/packages/excalidraw/data/url";
import {getBaiduVideoNameByUrl, getYoutubeThumbUrlByUrl} from "@/Utility0";
import {getCardList} from "@model/card";
import {postMessage} from "@/common/event";

const DialogLibraryImport = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [labels,setLabels] = useState({title:'',urlLabel:'',selectLabel:'',dragLabel:'',dragImageThumbName:'',fileType:'',ext:''});
    const [importMode,setImportMode] = useState(IMPORT_FILE_MODE_IMPORTMODE);
    const [selectFile,setSelectFile] = useState('');
    const [inputUrl,setInputUrl] = useState('');
    const [isDisabledCopyMode,setIsDisabledCopyMode] = useState(false);

    const mszType = useRef<any>('');
    const dragRef = useRef(null);
    const mCallback = useRef(null);

    useEffect(() => {
        let szImportMode = localStorage.getItem(KEY_FILE_IMPORT_MODE) || IMPORT_FILE_MODE_IMPORTMODE;
        if (szImportMode == IMPORT_FILE_MODE_ASKME){
            szImportMode = localStorage.getItem(KEY_FILE_IMPORT_MODE_LIBRARY) || IMPORT_FILE_MODE_IMPORTMODE;
        }
        setImportMode(szImportMode);

        ipcOn('download-file-progress',(event,args)=>{
            if (args.progress == -1){
                message.error('InvalidFileFormat');
                window.closeProgress();
                return;
            }
            window.updateProgress(t("Downloading") + `(${(args.progress*100).toFixed(2)}%)`);
            if (args.isFinished){
                //下载完成了。。。
                window.closeProgress();

                window.importFileToLibrary({path:args.filePath,name:getFileName(args.filePath),sandboxPath:true},IMPORT_FILE_MODE_IMPORTMODE,(data:any)=>{
                    if (props.onCloseCallback){
                        props.onCloseCallback();
                    }
                    if (mCallback.current){
                        mCallback.current(data);
                    }else{
                        window.onShowMessageTip(t("Import complete"),()=>{
                            //转到library
                            window.showLibraryFilePreview(data);
                        })
                    }
                },mCallback.current == null)
            }
        })

        /**
         * 临时用一下...
         */
        window.onCloseProgressCallback = ()=>{
            ipcInvoke('cancel-download');
        }

        return ()=>{
            ipcRemoveThisAll('download-file-progress');
            delete window.onCloseProgressCallback;
        }
    }, []);

    const onShowDialog = (szType:any,callback:any)=>{
        mszType.current = szType;
        mCallback.current = callback;

        setIsShowDialog(true);
        let labels:any = {};
        if (szType == 'pdf'){
            labels = {
                title:t("Import PDF"),
                urlLabel:t("PDF URL"),
                selectLabel:t("OrSelectPdfFile"),
                dragImageThumbName:'import_drag_thumb_pdf',
                dragLabel:t("DragPdfFileToHere"),
                fileType:t("PDF"),
                ext:'.pdf',
            }
        }else if (szType == 'video'){
            labels = {
                title:t("Import video"),
                urlLabel:t("Video URL"),
                selectLabel:t("OrSelectVideoFile"),
                dragImageThumbName:'import_drag_thumb_video',
                dragLabel:t("DragVideoFileToHere"),
                fileType:t("Video"),
                ext:'.mp4,.mov'
            }
        }else if (szType == 'image'){
            labels = {
                title:t("Import image"),
                urlLabel:t("Image URL"),
                selectLabel:t("OrSelectImageFile"),
                dragImageThumbName:'import_drag_thumb_image',
                dragLabel:t("DragImageFileToHere"),
                fileType:t("Image"),
                ext:getImageExt()
            }
        }else if (szType == 'file'){
            labels = {
                title:t("Import file"),
                urlLabel:t("File URL"),
                selectLabel:t("OrSelectAnyFile"),
                dragImageThumbName:'import_drag_thumb_file',
                dragLabel:t("DragAnyFileToHere"),
                fileType:t("File"),
                ext:'*'
            }
        }
        setLabels(labels);
    }

    const uploadProps:{ beforeUpload: (file) => string } = {
        beforeUpload:(file)=>{
            setSelectFile(file);
            return Upload.LIST_IGNORE
        }
    }

    /**
     * 导入并关闭
     */
    const importAndClose = ()=>{
        if (isValidUrl(inputUrl)){
            window.showProgress(t("Downloading"));
            let szFileName = generateUUID2();
            ipcInvoke('download-file',{url:inputUrl,fileName:szFileName,type:mszType.current})
        }else{
            window.importFileToLibrary(selectFile,importMode,(data:any)=>{
                if (props.onCloseCallback){
                    props.onCloseCallback();
                }
                if (mCallback.current){
                    mCallback.current(data);
                }else{
                    window.onShowMessageTip(t("Import complete"),()=>{
                        //转到library
                        window.showLibraryFilePreview(data);
                    })
                }

            },mCallback.current == null).then(res=>{
                //如果是在library.刷新
                // if (isInPageLibrary()){
                //     window.globalRefreshList('refreshLibraryList_')
                // }
            })
        }
    }

    /**
     * 导入在线视频并关闭。。支持的这几个
     */
    const importLiveVideoAndClose = ()=>{
        window.createUrlNewLibraryItem(inputUrl).then(data => {
            if (isYoutubeUrl(inputUrl)){
                postMessage(EVENT_OPEN_LIBRARY_ITEM,{...data});
            }else{
                window.onShowMessageTip(t("Import complete"), () => {
                    //转到library
                    window.showLibraryFilePreview(data);
                })
            }


            if (props.onCloseCallback){
                props.onCloseCallback();
            }
        });
    }


    return <Modal width={526} zIndex={2005} styles={{
        content:{
            background:'var(--background-color)'
        }
    }}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div className={'default-font-size'} style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title-large'}>{labels.title}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>
            <span className={'dialog-title'}>{labels.urlLabel + ":"}</span>
            <input value={inputUrl} className={'input-border-5f mt-6'} onInput={(e)=>{
                setInputUrl(e.currentTarget.value);
                if (isValidUrl(e.currentTarget.value)) {
                    //禁用linkmode
                    setImportMode('importMode');
                    if (mszType.current == 'video' && isSupportVideoAnnoUrl(e.currentTarget.value)) {
                        setIsDisabledCopyMode(true);
                    }
                }

            }}/>
            <span className={'dialog-title mt-24'}>{labels.selectLabel}</span>
            <div className={'flex-row-vertical-center border-no-height mt-6'} style={{padding: '12px 12px',border:'1px solid var(--input-border-color-5f5f5f)'}}>
                <div className={'border-no-height flex-center cursor-pointer'} style={{
                    height: '32px',
                    padding: '0 10px',
                    flexShrink:'0',
                    background: isDarkMode()?'#3F3F3F':'var(--card-latex-block-background-color)'
                }} onClick={()=>{
                    dragRef.current?.upload?.uploader?.fileInput?.click();
                }}>{t("Choose file")}</div>
                <span className={'ml-10 span-single-line'}>{(selectFile?.name)}</span>
            </div>

            <div className={isDarkMode() ? 'drag-dashed-border-dark' : 'drag-dashed-border'}
                 style={{margin: '22px 0', height: '150px', width: '480px'}}>

                <Dragger ref={dragRef} {...uploadProps} accept={labels.ext} onDrop={(e)=>{
                    if (e.dataTransfer.files.length >= 1) {
                        const szFileName = e.dataTransfer.files[0].name.toLowerCase();
                        if (mszType.current == 'pdf') {
                            if (!szFileName.endsWith('.pdf')) {
                                message.error(t("InvalidFileFormat"))
                            }
                        }else if (mszType.current == 'image') {
                            if (!isImage(szFileName)) {
                                message.error(t("InvalidFileFormat"))
                            }
                        }else if (mszType.current == 'video') {
                            if (!isVideo(szFileName)) {
                                message.error(t("InvalidFileFormat"))
                            }
                        }
                        if (e.dataTransfer.files.length >1) {
                            message.info(t("OneOneBeAdded").replace('{0}', labels.fileType))
                        }
                    }
                }}
                         style={{outline: 'none', background: 'transparent', border: 'none'}}>
                    <p className="ant-upload-text">
                        <img style={{width: '32px', height: '32px'}}
                             src={getImagePathWithTheme(labels.dragImageThumbName)}/>
                    </p>

                    <p className={'default-font-family'} style={{
                        color: 'var(--color-666666)',
                        marginTop: '6px'
                    }}>{labels.dragLabel}</p>
                </Dragger>
            </div>

            <span className={'dialog-title'}>{t("Import mode") + ':'}</span>

            <ConfigProvider
                theme={{
                    components: {
                        Radio: {
                            /* 这里是你的组件 token */
                            colorBgContainerDisabled:'transparent',
                            colorBorder:'var(--radio-border-color)',
                            colorBgContainer:'transparent'
                        },
                    },
                }}>
                <Radio.Group className={'default-font-size'} style={{marginTop: '8px',gap:'8px',display:'flex',flexDirection:'column',color:'var(--text-color)'}} onChange={(e) => {
                    setImportMode(e.target.value);
                    localStorage.setItem(KEY_FILE_IMPORT_MODE_LIBRARY,e.target.value);
                }} value={importMode} options={[
                    {
                        value: 'importMode',
                        label: <div className={'flex-row-vertical-center mt-2'}><span style={{color:isDisabledCopyMode?'var(--color-888888)':'var(--text-color)'}} className={'default-font-color default-font-family'}>{t('Copy mode')}</span><Tooltip arrow={false} zIndex={MAX_Z_INDEX} title={t("CopyTheFileToYourLibrary")}>
                            <img className={'img-14 ml-4 cursor-pointer'} src={getImagePath('file_mode_help')}/>
                        </Tooltip></div>,
                        disabled: isDisabledCopyMode
                    },
                    {
                        value: 'linkMode',
                        label: <div className={'flex-row-vertical-center mt-2'}><span style={{color:isValidUrl(inputUrl)?'var(--color-888888)':'var(--text-color)'}} className={'default-font-color default-font-family'}>{t('Link mode')}</span><Tooltip arrow={false} zIndex={MAX_Z_INDEX} title={t("AccessOriginalFileWithout")}>
                            <img className={'img-14 ml-4 cursor-pointer'} src={getImagePath('file_mode_help')}/>
                        </Tooltip></div>,
                        disabled:isValidUrl(inputUrl)
                    }
                ]}>

                </Radio.Group>
            </ConfigProvider>


            <div className={'flex-center mt-32 mb-4 default-font-size'}>
                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    disabled={isStringNullOrEmpty(selectFile) && !isValidUrl(inputUrl)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        if (mszType.current == 'video' && isSupportVideoAnnoUrl(inputUrl)) {
                            if (mCallback.current) {
                                if (props.onCloseCallback){
                                    props.onCloseCallback();
                                }
                                let szType = '';
                                let szName = '';
                                let szThumbUrl = '';
                                if (isYoutubeUrl(inputUrl)){
                                    szType = 'youtube'
                                    szThumbUrl = getYoutubeThumbUrlByUrl(inputUrl);
                                }else if (isBilibiliUrl(inputUrl)){
                                    szType = 'bilibili';
                                }else if (isBaiduVideoUrl(inputUrl)){
                                    szType = 'baidu';
                                    szName = getBaiduVideoNameByUrl(inputUrl);
                                }
                                mCallback.current({fileName:inputUrl,isAbsolutePath:false,name:szName,type:szType,thumbUrl:szThumbUrl})
                            }else {
                                //检测库里面是否已经有了...
                                if (isSupportVideoAnnoUrl(inputUrl)){
                                    getCardList(-1,0,'liveVideo',null,null).then((arrayLibrarys:any)=>{
                                        const libraryItem = arrayLibrarys.find(p=>p.fileName == inputUrl);
                                        if (libraryItem){
                                            // message.info(t('LinkExist'));
                                            window.showMessageTip(t("LinkExist"),t("View"),"",()=>{
                                                postMessage(EVENT_OPEN_LIBRARY_ITEM,{...libraryItem});
                                                if (props.onCloseCallback){
                                                    props.onCloseCallback();
                                                }
                                                window.closeMessageTip();
                                            })
                                            // window.showMessageBox(t("DuplicateFileFound"), t("TheSameFileAlreadyExists"), t("CreateNewCopy"), t("Ok"), async () => {
                                            //     //create new copy-----------
                                            //     //导入视频链接到库...
                                            //     importLiveVideoAndClose()
                                            // }, () => {
                                            //     // window.closeProgress();
                                            //     if (props.onCloseCallback){
                                            //         props.onCloseCallback();
                                            //     }
                                            // })
                                        }else{
                                            importLiveVideoAndClose();
                                        }
                                    })
                                }
                            }
                        }else {
                            //import
                            if (importMode == IMPORT_FILE_MODE_IMPORTMODE) {//连续，导入模式，判断是否有文件
                                window.showProgress();
                                const szExistFileName = false;//不要再检测了。各种要求...麻烦....await ipcInvoke('cmp-file-md5', {filePath: selectFile.path});
                                window.closeProgress();
                                if (szExistFileName) {
                                    window.showMessageBox(t("DuplicateFileFound"), t("TheSameFileAlreadyExists"), t("CreateNewCopy"), t("Ok"), async () => {
                                        //create new copy-----------
                                        importAndClose();
                                    }, () => {
                                        // window.closeProgress();
                                        if (props.onCloseCallback){
                                            props.onCloseCallback();
                                        }
                                    })
                                } else {
                                    //单个文件copy----------------
                                    importAndClose()
                                }
                            } else {
                                importAndClose();
                            }
                        }
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Import")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogLibraryImport;



















